import {
  Button,
  HStack,
  Icon,
  Image,
  Spinner,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { KYDOrganizationFull } from "@common/interfaces/KYDOrganization";
import { FaCheck, FaWindowClose } from "react-icons/fa";

const MetaAdsSetting = ({
  organization,
  onConnect,
  onDisconnect,
  isLoading,
  show = false,
}: {
  organization?: Pick<KYDOrganizationFull, "ads_manager">;
  onConnect: () => void;
  onDisconnect: () => void;
  isLoading: boolean;
  show?: boolean;
}) => {
  if (!show) {
    return null;
  }

  return (
    <Stack w="full">
      <Text fontSize="lg" fontWeight="medium">
        Meta Ads Manager
      </Text>
      <VStack w="full" justifyContent={"flex-start"} alignItems={"flex-start"}>
        {isLoading ? (
          <VStack w="full" alignItems={"center"} justifyContent={"center"}>
            <Spinner />
          </VStack>
        ) : organization?.ads_manager?.needs_login ? (
          <>
            <VStack alignItems={"flex-start"}>
              <HStack>
                <Icon as={FaWindowClose} color="red" />
                <Text>
                  Your organization is{" "}
                  <Text fontWeight={"bold"} display="inline">
                    not connected
                  </Text>{" "}
                  to Meta ads and can't manage campaigns via KYD dashboard.
                </Text>
              </HStack>
              <Button
                background="#5890FF"
                color="white"
                leftIcon={<Image src={"/fb-logo.png"} w={"16px"} h={"16px"} />}
                _hover={{
                  background: "#5890FF",
                }}
                onClick={onConnect}
                w="full"
                flexGrow={1}
              >
                Continue with Facebook
              </Button>
            </VStack>
          </>
        ) : (
          <VStack w="full" alignItems={"flex-start"}>
            <HStack>
              <Icon as={FaCheck} color="green" />
              <Text>
                Your organization is{" "}
                <Text fontWeight={"bold"} display="inline">
                  connected
                </Text>{" "}
                to Meta ads manager and can manage campaigns via KYD dashboard.
              </Text>
            </HStack>
            <Button onClick={onDisconnect} w="full" flexGrow={1}>
              Disconnect
            </Button>
          </VStack>
        )}
      </VStack>
    </Stack>
  );
};

export default MetaAdsSetting;
